import React, { useEffect, useState } from 'react'
import Card from '../../../shared/components/card/card'
import Cookies from 'js-cookie'
import axios from "axios";
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import Notifications from '../notifications/notifications'

const Cards = ({ socket }) => {
    const user = useSelector((state) => state.userDetails.user);
    const [allregisteruser, setallregisteruser] = useState(0)
    const [alllisting, setalllisting] = useState(0)
    const [mylisting, setmylisting] = useState(0)
    const [mybidding, setmybidding] = useState(0)
    const [allcategory, setallcategory] = useState(0)
    const [allsubcategory, setallsubcategory] = useState(0)
    const [loadingAllRegUser, setLoadingAllRegUser] = useState(true);
    const [loadingAllListing, setLoadingAllListing] = useState(true);
    const [loadingMyListing, setLoadingMyListing] = useState(true);
    const [loadingBidding, setLoadingBidding] = useState(true);
    const [loadingCategories, setLoadingCategories] = useState(true);
    const [loadingSubCategories, setLoadingSubCategories] = useState(true);


    useEffect(async () => {
        if (user && user.role[0] == "admin") {
            const registerUser = await getAllRegisterUsers();
            const alllist = await countAllListing()
            const allcategory = await countAllCategory()
            const allsubcategory = await countAllSubCategory()

            setallregisteruser(registerUser)
            setLoadingAllRegUser(false);

            setalllisting(alllist)
            setLoadingAllListing(false);

            setallcategory(allcategory)
            setLoadingCategories(false);

            setallsubcategory(allsubcategory)
            setLoadingSubCategories(false);

        }

        if (user.role[0] == "user") {
            const mylist = await countMyListing(user._id)
            setmylisting(mylist)
            setLoadingMyListing(false);

            const mybid = await countMyBidding(user._id)
            setmybidding(mybid)
            setLoadingBidding(false);

        }
    }, [user])





    const [allRegisterUserRole, setallRegisterUserRole] = useState(["admin"])
    const [allListingRole, setallListingRole] = useState(["admin"])
    const [allCategoryRole, setallCategoryRole] = useState(["admin"])
    const [allSubcategoryRole, setallSubcategoryRole] = useState(["admin"])
    const [NotificationRole, setNotificationRole] = useState(["admin"])

    const [MyBiddingRole, setmyBiddingRole] = useState(["user"])
    const [myListingRole, setmyListingRole] = useState(["user"])

    const getAllRegisterUsers = async () => {
        const response = await axios.request({
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/count-all-register-user`
        })
        if (response.data.success) {
            return response.data.data;
        }
        else {
            toast.error(response.data.message);
            return "0";
        }


    }

    const countAllListing = async () => {
        const response = await axios.request({
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/count-all-listing`
        })
        if (response.data.success) {

            return response.data.data;
        }
        else {
            toast.error(response.data.message)
            return "0"
        }

    }

    const countMyListing = async (user_id) => {

        const response = await axios.request({
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            data: { user_id: user_id },
            url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/count-my-listing`
        })
        if (response.data.success) {
            return response.data.data;
        }
        else {
            toast.error(response.data.message)
            return "0"
        }


    }

    const countAllCategory = async () => {
        const response = await axios.request({
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/count-all-category`
        })
        if (response.data.success) {
            return response.data.data;
        }
        else {
            toast.error(response.data.message)
            return "0"
        }


    }

    const countAllSubCategory = async () => {
        const response = await axios.request({ method: 'get', headers: { 'Content-Type': 'application/json', 'Authorization': Cookies.get('token') }, url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/count-all-subcategory` })
        if (response.data.success) {
            return response.data.data;
        }
        else {
            toast.error(response.data.message)
            return "0"
        }


    }



    const countMyBidding = async (user_id) => {

        const response = await axios.request({
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            data: { _id: user_id },
            url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/get-my-bidding`
        })
        if (response.data.success) {
            // console.log('----->',response.data.products)
            return response.data.products.length;
        }
        else {
            toast.error(response.data.message)
            return "0"
        }


    }

    return (
        <>
            <div className="row dashboardCardRow">

                {(MyBiddingRole.indexOf(user.role[0]) > -1) &&
                    <div className="col-md-6 my-md-0 my-2">
                        <Card styleName="circleStyle2" title="My Bidding" num={`${mybidding}`} lnk="/my-bids" loading={loadingBidding} />
                    </div>
                }

                {(myListingRole.indexOf(user.role[0]) > -1) &&

                    <div className="col-md-6 my-md-0 my-2">
                        <Card styleName="circleStyle2" title="My Listing" num={`${mylisting}`} lnk="/user-listing" loading={loadingMyListing} />

                    </div>
                }
                <div className="col-md-8">
                    <div className="row">
                        {(allListingRole.indexOf(user.role[0]) > -1) &&

                            <div className="col-md-6 my-md-0 my-2">
                                <Card styleName="circleStyle1" title="Total No listings" num={`${alllisting}`} lnk="/admin-listing" loading={loadingAllListing} />

                            </div>
                        }



                        {(allRegisterUserRole.indexOf(user.role[0]) > -1) &&
                            <div className="col-md-6 my-md-0 my-2">
                                <Card styleName="circleStyle2" title="All Register User" num={`${allregisteruser}`} lnk="/registered-users" loading={loadingAllRegUser} />
                            </div>
                        }

                    </div>

                    <div className="row">
                        {(allCategoryRole.indexOf(user.role[0]) > -1) &&
                            <div className="col-md-6 my-md-0 my-2">
                                <Card styleName="circleStyle2" title="All Category" num={`${allcategory}`} lnk="/category" loading={loadingCategories} />
                            </div>
                        }

                        {(allSubcategoryRole.indexOf(user.role[0]) > -1) &&
                            <div className="col-md-6 mb-6 my-md-0 my-2">
                                <Card styleName="circleStyle2" title="All SubCategory" num={`${allsubcategory}`} lnk="/sub-category" loading={loadingSubCategories} />
                            </div>
                        }

                    </div>


                </div>
                {(NotificationRole.indexOf(user.role[0]) > -1) &&
                    <div className="col-md-4">
                        <Notifications socket={socket} />
                    </div>
                }

            </div>




            {/* <div className="row">
                <div className="col-md-6 mb-3">
                    <Card styleName="circleStyle3" title="Registered Users" num="9964" lnk="/registered-users"/>
                </div>
                <div className="col-md-6">
                    <Card styleName="circleStyle4" title="Total Revenue" num="$610" lnk="#"/>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <Card styleName="circleStyle5" title="Total No of Categories" num="164" lnk="/category"/>
                </div>
                <div className="col-md-6">
                    <Card styleName="circleStyle5" title="Total No of Subcategories" num="430" lnk="/sub-category"/>
                </div>
            </div> */}
        </>
    )
}

export default Cards
